import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const PAPER = {
  A4: [210, 297],
  A3: [297, 420],
  Letter: [216, 279],
  Legal: [216, 356],
};

export async function exportToPDF(elementId, filename, opts) {
  const el = document.getElementById(elementId);
  if (!el) return;
  const canvas = await html2canvas(el, { scale: 2, useCORS: true, backgroundColor: "#ffffff", logging: false });
  const imgData = canvas.toDataURL("image/png");

  let [pw, ph] = PAPER[opts.paper] || PAPER.A4;
  if (opts.orientation === "landscape") [pw, ph] = [ph, pw];

  const pdf = new jsPDF({ orientation: opts.orientation, unit: "mm", format: [pw, ph] });
  const margin = Number(opts.margin) || 10;
  const availW = pw - margin * 2;
  const availH = ph - margin * 2;

  const ratio = canvas.width / canvas.height;
  let imgW = availW;
  let imgH = imgW / ratio;

  const scaling = opts.scaling;

  if (scaling === "no_scaling") {
    // full width, split across multiple pages by height
    imgW = availW;
    imgH = imgW / ratio;
    let remaining = imgH;
    let position = 0;
    if (imgH <= availH) {
      pdf.addImage(imgData, "PNG", margin, margin, imgW, imgH);
    } else {
      while (remaining > 0) {
        pdf.addImage(imgData, "PNG", margin, margin - position, imgW, imgH);
        remaining -= availH;
        if (remaining > 0) {
          pdf.addPage([pw, ph], opts.orientation);
          position += availH;
        }
      }
    }
  } else if (scaling === "fit_columns") {
    // fit width, keep aspect (may overflow height -> paginate)
    imgW = availW;
    imgH = imgW / ratio;
    if (imgH <= availH) {
      pdf.addImage(imgData, "PNG", margin, margin, imgW, imgH);
    } else {
      let remaining = imgH, position = 0;
      while (remaining > 0) {
        pdf.addImage(imgData, "PNG", margin, margin - position, imgW, imgH);
        remaining -= availH;
        if (remaining > 0) { pdf.addPage([pw, ph], opts.orientation); position += availH; }
      }
    }
  } else if (scaling === "fit_rows") {
    // fit height, keep aspect
    imgH = availH;
    imgW = imgH * ratio;
    pdf.addImage(imgData, "PNG", margin, margin, imgW, imgH);
  } else {
    // fit_one_page / fit_sheet -> fit entirely within one page
    imgW = availW;
    imgH = imgW / ratio;
    if (imgH > availH) {
      imgH = availH;
      imgW = imgH * ratio;
    }
    const x = margin + (availW - imgW) / 2;
    pdf.addImage(imgData, "PNG", x, margin, imgW, imgH);
  }

  pdf.save(`${filename}.pdf`);
}
